<!--template>
  <div class="language-menu">
    <div class="language-menu__toggle" @click="toggleMenu" :style="{left: l,right:r,bottom:b,top:t}">
      <span v-if="currentLanguage === 'English'">🇺🇸</span>
      <span v-else-if="currentLanguage === '简体中文'">🇨🇳</span>
      <span v-else-if="currentLanguage === '繁體中文'">tw</span>
      <img v-else :src="enIcon">
    </div>
    <ul v-show="isOpen" class="language-menu__list" :style="{left: l,right:r,bottom:b,top:'calc(24px + '+t+')'}">
      <li :class="{'language-menu__selected': currentLanguage === language}" v-for="(language, index) in languages"
          :key="index" @click="changeLanguage(language)">
        <span v-if="language === 'English'">sg</span>
        <span v-if="language === '简体中文'">🇨🇳</span>
        <span v-if="language === '繁體中文'">tw</span>
        <span>{{ language }}</span>
      </li>
    </ul>
  </div>
</template-->
<template>
  <div class="language-menu">
    <div class="language-menu__toggle" @click="toggleMenu" :style="{left: l, right: r, bottom: b, top: t}">
      <span v-if="currentLanguage === 'English'">
        <img src="https://flagcdn.com/w320/us.png" alt="美国国旗" style="width: 24px; height: 16px;">
      </span>
      <span v-else-if="currentLanguage === '简体中文'">
        <img src="https://flagcdn.com/w320/cn.png" alt="中国国旗" style="width: 24px; height: 16px;">
      </span>
      <span v-else-if="currentLanguage === '繁體中文'">
        <img src="https://flagcdn.com/w320/tw.png" alt="台湾地区旗帜" style="width: 24px; height: 16px;">
      </span>
    </div>
    <ul v-show="isOpen" class="language-menu__list" :style="{left: l, right: r, bottom: b, top: 'calc(24px + ' + t + ')'}">
      <li :class="{'language-menu__selected': currentLanguage === language}" 
          v-for="(language, index) in languages"
          :key="index" @click="changeLanguage(language)">
        <span v-if="language === 'English'">
          <img src="https://flagcdn.com/w320/sg.png" alt="美国国旗" style="width: 24px; height: 16px;">
          English
        </span>
        <span v-else-if="language === '简体中文'">
          <img src="https://flagcdn.com/w320/cn.png" alt="中国国旗" style="width: 24px; height: 16px;">
          简体中文
        </span>
        <span v-else-if="language === '繁體中文'">
          <img src="https://flagcdn.com/w320/tw.png" alt="台湾地区旗帜" style="width: 24px; height: 16px;">
          繁體中文
        </span>
      </li>
    </ul>
  </div>
</template>


<script>
import enIcon from './en.png';

export default {
  props: {
    t: '0.5rem',
    l: '',
    r: '1rem',
    b: ''
  },
  data() {
    return {
      enIcon: enIcon,
      isOpen: false,
      languages: ['English', '简体中文', '繁體中文'], // 语言列表
      currentLanguage: '繁體中文', // 当前选中的语言
    };
  },
  mounted() {
    // 获取当前语言
    const language = localStorage.getItem('language');
    if (language) {
      this.changeLanguage(language);
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    switchLanguage(lang) {
      this.$i18n.locale = lang;
      // 缓存
    },
    changeLanguage(language) {
      // 根据需要进行语言切换的逻辑处理
      if (language === 'English') {
        this.switchLanguage('en');
      } else if (language === '简体中文') {
        this.switchLanguage('zh');
      } else if (language === '繁體中文') {
        this.switchLanguage('zhs');
      }
      // 更新当前选中的语言
      this.currentLanguage = language;
      localStorage.setItem('language', language);
      // 关闭菜单
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.language-menu {
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
}

.language-menu__toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  width: 24px;
  height: 24px;
  position: fixed;
  right: 1rem;
  top: 0.5rem;
  z-index: 8888;
}

.language-menu__list {
  z-index: 8888;
  position: absolute;
  top: calc(24px + 0.5rem);
  right: 1rem;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  min-width: 120px;
}

.language-menu__list li {
  padding: 10px;
  cursor: pointer;
}

.language-menu__list li span:nth-child(2) {
  margin-left: 10px;
}

.language-menu__selected {
  background-color: #409eff;
  color: #fff;
}
</style>
